import Vue from 'vue';

export default Vue.extend({
  name: 'customAgGridNoRowsOverlay',
  template: `
          <div
        class="flex flex-col justify-center items-center w-full h-full"
        style="max-width: 500px; row-gap: 12px; margin: auto; pointer-events: none;"
        >
      <h3
        v-if="params.title"
        class="font-bold">
        {{ params.title }}
      </h3>

      <p v-if="params.text">
        {{ params.text }}
      </p>

      <div class="flex flex-col sm:flex-row gap-3 mt-5" v-if="params.buttonText || params.buttonSecondaryText">
        <vs-button
          v-if="params.buttonText && params.actionButtonClicked"
          style="pointer-events: auto;"
          :icon-pack="params.buttonIconPack || 'feather'"
          :icon="params.buttonIcon"
          @click="params.actionButtonClicked">
          {{ params.buttonText }}
        </vs-button>
        
        <vs-button
          v-if="params.buttonSecondaryText && params.actionButtonSecondaryClicked"
          type="border"
          style="pointer-events: auto;"
          :icon-pack="params.buttonSecondaryIconPack || 'feather'"
          :icon="params.buttonSecondaryIcon"
          @click="params.actionButtonSecondaryClicked">
          {{ params.buttonSecondaryText }}
        </vs-button>
      </div>
    </div>
    `,
  data() {
    return {};
  },
  beforeMount() {},
  mounted() {},
  methods: {},
});
